import * as Yup from 'yup'

export const usePrescricaoSchema = Yup.object().shape({
  token: Yup.string().required('Código da prescrição é obrigatório'),
  codigo: Yup.string().required('Código de desbloqueio é obrigatório'),
  nome: Yup.string().required('Nome é obrigatório'),
  nomeFarmacia: Yup.string().required('Nome da farmácia é obrigatório'),
  cpf: Yup.string()
    .matches(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/, 'CPF deve estar no formato 000.000.000-00')
    .required('CPF é obrigatório'),
  crf: Yup.string()
    .matches(/^\d+$/, 'CRF deve conter apenas números')
    .min(1, 'CRF deve ter no mínimo 1 caractere')
    .max(10, 'CRF deve ter no máximo 10 caracteres')
    .required('CRF é obrigatório'),
  uf: Yup.object().nullable().required('UF é obrigatório'),
})
